<template>
  <layout-base id="gtr-emails-html" max-width="700px">
    <layout-pdf>
      <!-- INTRO -->
      <report-intro :title="email.data.title" :sub-title="email.data.sub_title" :date="email.data.email_date" />
      <!-- SECTION REPUTATION -->
      <report-reputation :reputation="email.data.reputation" />
    </layout-pdf>
    <layout-pdf margin-top="600px" padding-top="40px">
      <!-- INTRO -->
      <report-intro
        :title="email.data.title"
        :sub-title="email.data.sub_title"
        :date="email.data.email_date"
        :no-title="true"
      />
      <!-- SECTION COMPETITION -->
      <report-competition
        :competition="email.data.competition"
        v-if="email.data.competition"
        :has-cta="false"
        :flex="true"
      />
    </layout-pdf>
    <layout-pdf margin-top="600px" padding-top="40px">
      <!-- INTRO -->
      <report-intro
        :title="email.data.title"
        :sub-title="email.data.sub_title"
        :date="email.data.email_date"
        :no-title="true"
      />
      <!-- SECTION AUDIENCE -->
      <report-audience :audience="email.data.audience" width="100%" v-if="email.data.audience" />
    </layout-pdf>

    <layout-pdf margin-top="600px" padding-top="40px">
      <!-- INTRO -->
      <report-intro
        :title="email.data.title"
        :sub-title="email.data.sub_title"
        :date="email.data.email_date"
        :no-title="true"
      />
      <!-- SECTION RANKING -->
      <report-ranking :ranking="email.data.ranking" width="100%" v-if="email.data.ranking" />
    </layout-pdf>
    <layout-pdf margin-top="600px" padding-top="40px">
      <!-- INTRO -->
      <report-intro
        :title="email.data.title"
        :sub-title="email.data.sub_title"
        :date="email.data.email_date"
        :no-title="true"
      />
      <!-- SECTION RADAR -->
      <report-radar :radar="email.data.radar" v-if="email.data.radar" :has-cta="false" :separate="false" />
    </layout-pdf>
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import LayoutPdf from '@/components/Layout/Pdf.vue'
import ReportIntro from '@/components/Report/Intro.vue'
import ReportReputation from '@/components/Report/Reputation.vue'
import ReportCompetition from '@/components/Report/Competition.vue'
import ReportRanking from '@/components/Report/Ranking.vue'
import ReportAudience from '@/components/Report/Audience.vue'
import ReportRadar from '@/components/Report/Radar.vue'

export default {
  name: 'ReportGlobal',
  components: {
    LayoutBase,
    LayoutPdf,
    ReportIntro,
    ReportReputation,
    ReportCompetition,
    ReportRanking,
    ReportAudience,
    ReportRadar,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
